import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { LoadIzzyUI } from 'izzy-ui';

LoadIzzyUI();

// Apply the Izzy theme overlay immediately so CSS is active before render.
// The theme CSS is compiled into main.scss via _izzy-theme.scss, so no
// dynamic loading is needed — we just need the attribute on <html>.
document.documentElement.setAttribute('data-theme-overlay', 'izzy');

async function initAndBootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .then(ref => {
      //LogStatus('Bootstrap success: ' + ref);
    })
    .catch(err => console.error(err));
}

initAndBootstrap();
